import { Text } from "@mantine/core";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetApi, useTheme } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setAutofillPopup } from "src/redux/slices/generatorFeaturesSlice";
import { Flex } from "src/styled";
import { getYachtId } from "src/utils";

import { AutofillPopup } from "./Autofill.styled";

const mapper = (data: any) => {
  if (!data) return [];
  return [...new Set(data.list)];
};

const Autofill = () => {
  const dispatch = useDispatch();
  const theme = useTheme() as any;
  const { setValue, getValues } = useFormContext();
  const { logbookId } = useParams();
  const { autofillPopup } = useSelector(state => state.generatorFeaturesSlice);

  const value = getValues(autofillPopup?.inputId ?? "");

  const { data, refetch } = useGetApi({
    request: "search-entry-values",
    body: {
      params: {
        text: value,
        searchID: autofillPopup?.searchId,
        lbid: logbookId,
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
    mapper,
  });

  useEffect(() => {
    if (autofillPopup && value?.length > 3) {
      void refetch();
    }
  }, [autofillPopup, refetch, value]);

  const handleSelect = (item: string) => {
    if (!autofillPopup) return;
    setValue(autofillPopup.inputId, item);
    dispatch(setAutofillPopup(null));
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;

      if (!target?.closest(".autofill-popup")) {
        dispatch(setAutofillPopup(null));
      }
    };

    const handleScroll = () => {
      dispatch(setAutofillPopup(null));
    };

    document.addEventListener("mousedown", handleClickOutside);
    const pageContainer = document.getElementById("page-container");
    pageContainer?.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      pageContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch]);

  if (!autofillPopup || !data || data.length === 0) return null;
  return (
    <AutofillPopup
      className="autofill-popup"
      style={{
        top: autofillPopup?.top,
        left: autofillPopup?.left,
      }}>
      {data.map((item: any, i: number) => (
        <Flex
          key={`${item}-${i}`}
          onClick={() => handleSelect(item)}
          style={{
            cursor: "pointer",
            borderBottom: `2px solid ${theme.colors.main[6]}`,
          }}>
          <Text style={{ textTransform: "uppercase" }}>{item}</Text>
        </Flex>
      ))}
    </AutofillPopup>
  );
};
export default Autofill;
